
export default {
    minDate:new Date(1900,1,1),
    IdBusiType:{
        return:35
    }
}